<template>
  <div>
    <div class="py-4 ma-0 d-flex justify-space-between align-start">
      <div class="d-flex flex-column px-0" style="max-width: 600px;">
        <div class="d-flex align-center">
          <p
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('common.roles.author') }}:
            <span class="font-weight-medium">{{ author }}</span>
          </p>
        </div>
        <div class="d-flex align-center">
          <p
            v-if="owner"
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('common.roles.owner') }}:
            <span class="font-weight-medium">{{ owner }}</span>
          </p>
        </div>
        <div class="d-flex align-center">
          <p
            v-if="coach"
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('common.roles.coach_one') }}:
            <span class="font-weight-medium">{{ coach }}</span>
          </p>
        </div>
        <div class="d-flex align-center ">
          <p
            v-if="hasCollaborators"
            class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
          >
            {{ $t('common.collaborator_other') }}:
            <span class="font-weight-medium">{{ joinCollaborators }} </span>
          </p>
        </div>
      </div>
      <div class="d-flex flex-column pl-1 align-end" style="max-width: 300px;">
        <p
          class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
        >
          {{ $t('common.country_one') }}:
          <span class="font-weight-medium"
            >{{ $t(`countries.${rev?.location.site.countryCodes[0]}`) }}
          </span>
        </p>
        <p
          class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0"
        >
          {{ $t('common.site_one') }}:
          <span class="font-weight-medium">{{ rev.location.site.name }}</span>
        </p>
        <p
          v-if="joinTags.length"
          class="paragraph blue-grey--text text--darken-3 font-weight-bold mb-0 text-right"
        >
          {{ $t('common.tag_other') }}:
          <span class="font-weight-medium">{{ joinTags }} </span>
        </p>
      </div>
    </div>
    <v-divider class="theme--print" />
  </div>
</template>

<script>
import userMixin from '@/mixins/userMixin'

export default {
  name: 'TeamsSolvingPrint',

  mixins: [userMixin],

  props: {
    rev: {
      type: Object,
      required: true,
    },
  },

  computed: {
    author() {
      const author = this.rev?.author
      return author ? this.getFullName(author) : {}
    },

    owner() {
      const owner = this.rev.team?.owner
      return owner ? this.getFullName(owner) : {}
    },

    coach() {
      const coach = this.rev.team?.coach
      return coach ? this.getFullName(coach) : null
    },

    collaborators() {
      if (!this.rev.team?.collaborators) return []
      return this.rev.team?.collaborators.map(collaborator =>
        this.getFullName(collaborator)
      )
    },

    hasCollaborators() {
      return Boolean(this.collaborators && this.collaborators.length)
    },

    joinCollaborators() {
      return this.collaborators.join(', ')
    },

    joinTags() {
      return this.rev?.location?.tags?.map(tag => tag.name)?.join(', ')
    },

    joinCategories() {
      return this.rev?.categories
        ?.map(category => this.$t(`common.categories.${category}`))
        ?.join(', ')
    },
  },
}
</script>
